export const ViewTypes = {
  AUCTIONS: 'cards/auctions',
  MARKET: 'cards/listed',
  INSTANT_BUY: 'cards/instant',
  TOP_PLAYERS: 'topPlayers',
  TOP_NBA_PLAYERS: 'topNbaPlayers',
  ALL_CARDS: 'cards/all',
  MANAGER_CARDS: 'managerCards',
  MANAGER_NBA_LINEUP: 'managerNbaLineup',
} as const;

export const FilterTypes = {
  CARDS_SORT_ORDER_BY: 'cardsSortOrder',
  SCORES_TYPE: 'scoresType',
  SCORES_SORT_BY: 'scoresSort',
  NBA_SCORES_SORT_BY: 'nbaScoresSort',
  NBA_LINEUP_SORT_BY: 'nbaLineupSort',
  RARITY: 'rarity',
  POSITION: 'position',
  CLUB: 'club',
  NBA_CLUB: 'nbaClub',
  GAME_WEEK: 'gameWeek',
  LEAGUE: 'league',
  COUNTRIES: 'countries',
  U23: 'u23',
  FIRST: '1st',
  SHIRT: 'shirt',
  SPECIAL_DESIGN: 'specialDesign',
  LEGENDS: 'legends',
  REWARD: 'reward',
  IN_SEASON: 'inSeason',
  LOW_5TH_SCORE: 'low5thScore',
  PLAYED_LAST_MATCH: 'playedLastMatch',
  AVAILABLE_ON_MARKET: 'availableOnMarket',
  PLAYED_PERCENTAGES: 'playedPercentages',
  RARITY_PRICES: 'rarityPrices',
  PRICES: 'prices',
  SCORES: 'scores',
  SEALED: 'sealed',
  INELIGIBLE: 'ineligible',
} as const;
